import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { newFetch, GET, POST } from '../../../../../helpers/fetch';
import MyEditor from '../../Rewards/MyEditor';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const BirthdayPoints = ({ history }) => {
  const [birthdayPoints, setBirthdayPoints] = useState(0);
  const token = localStorage.getItem('token');
  const handleSetBirthdayPoints = (e) => setBirthdayPoints(parseInt(e));
  const [editor, setEditor] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update the Associates Birthday Points\n and Birthday Email Message? '
      )
    ) {
      let api_path = `/reward/setting`;
      let response = await newFetch(POST, api_path, {
        birthday_points: birthdayPoints,
        email_content: editor,
      });

      if (response.success) ToastUtil.success(response.message);
    }
  };

  const fetchBirthdayPoints = async () => {
    let api_path = `/reward/setting`;
    let response = await newFetch(GET, api_path);

    response.success && setBirthdayPoints(response.data.birthday_points);
  };

  const fetchGeneralSettings = async () => {
    let api_path = `/admin/setting/8`;
    let response = await newFetch(GET, api_path);
    response.success && setEditor(response.data.value);
  };

  useEffect(() => {
    fetchBirthdayPoints();
    fetchGeneralSettings();
  }, []);

  return (
    <form onSubmit={(e) => handleSubmit(e)} className="d-flex flex-column">
      <div className="p-4 d-flex flex-column">
        <h5 className="mb-4 pb-2">Asssociate's Birthday Points</h5>
        <div className="mb-2">
          <label htmlFor="birthdayPoints" className="fw-semibold mb-2">
            Birthday Points
          </label>
          <input
            type="number"
            className="form-control text-end w-25"
            id="birthdayPoints"
            placeholder="Enter Birthday Points"
            value={birthdayPoints}
            onChange={(e) => handleSetBirthdayPoints(e.target.value)}
          />
        </div>
        <div className="mb-2">
          <label htmlFor="birthdayEmailContent" className="fw-semibold mb-2">
            Birthday Email Message
          </label>
          <MyEditor editor={editor} setEditor={setEditor} />
        </div>
      </div>

      <div
        style={{
          height: '4.5rem',
        }}
        className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
      >
        <button
          type="submit"
          className="btn btn-brand ms-3 adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Save changes
        </button>
      </div>
    </form>
  );
};

export default withRouter(BirthdayPoints);
